import { createIds } from 'helpers/idHelpers';

const getIds = (root: string) => {
  return createIds(root, 'logo', 'backdrop', 'filter', 'symbols', 'content', 'cart');
};

export default getIds;
